'use strict';

(function ($, window, document) {
    var $win = $(window);
    var $doc = $(document);
    var $body = $('body');
    var $header = $('.header');
    var $filtersHead = $('.section-filter .section__head');
    var filterHeadInitialHeight;

    var classes = {
        Hover: 'hover',
        Active: 'active',
        ShowNavMain: 'show-nav-main',
        FixedHeader: 'show-fixed-header',
        PageLoad: 'page-load',
        Expanded: 'expanded'
    };

    var is = {
        Mobile: false,
        Desktop: false,
        Tablet: false
    };

    var get = {
        Scroll: 0,
        WinWidth: 0,
        WinHeight: 0
    };

    var dataArticlesParent;
    var dataArticles;

    var articlesHeight;
    var articlesOffsetTop;
    var articleHighestOffsetBottom;

    window.ytPlayer = {};
    window.ytBgPlayer = {};

    var waitForFinalEvent = (function () {
        var timers = {};
        return function (callback, ms, uniqueId) {
            if (!uniqueId) {
                uniqueId = "Don't call this twice without a uniqueId";
            }
            if (timers[uniqueId]) {
                clearTimeout (timers[uniqueId]);
            }
            timers[uniqueId] = setTimeout(callback, ms);
        };
    })();
    /*
        # - Ready
    */

    $doc.ready(function() {
        loadVideoAPIs();
        addDeviceResolution();
        addBaseClickEvents();
        fullscreenVideo();
        smoothScroll();
        lockSectionFilter();
        sliderTicker();


        filterHeadInitialHeight = $filtersHead.outerHeight();

        
        AOS.init({
            offset: 0,
            duration: 1300,
        });

        
       
        $('.header__nav').scrollLock('enable');

        searchFormTransDelay();
    });

    $doc.on('lazybeforeunveil', function() {
        AOS.refresh();
    });

    /*
        # - Load
    */

    $win.on('load', function() {
        dataArticlesParent = $('.articles--four:not(.articles--four-static)').parent();
        dataArticles = $('.articles--four:not(.articles--four-static)').clone();

        $body.addClass(classes.PageLoad);

        $('html,body').animate({
            scrollTop: 0
        }, 50);

        if(location.hash == '#subscribe') {
            setTimeout(()=> {
                $("html, body").animate({ scrollTop: $(document).height() }, 1500);
            }, 1500)
        }

        $('.articles--four').isotope({
            itemSelector: '.article',
            percentPosition: true,
            getSortData: {
                date: '[data-timestamp]',
            },
        });

        calcArticlesPosition();

        $('.articles--two').isotope({
            itemSelector: '.article',
            percentPosition: true,
            animationOptions: {
                duration: 0,
                easing: 'linear',
                queue: false
            },
            transitionDuration: 0
        });

        calcArticlesPosition();

        if ($('.section--overlap').length) {
            articlesOverlap();
        }

        articlesRow();
        addArticlesAnimation();
        articlesRelated();
        feedTicker();

        sliderMobileInit();
        changeImage();
        calcFilterMobile();
        videos();
        accordionSetup();

        AOS.refresh();
        scrollme.init();

        $('.jsGallery').magnificPopup({
            removalDelay: 300,
            delegate: 'a:not("p a")', // child items selector, by clicking on it popup will open
            type: 'image',
            gallery: {
                enabled: true,
                tCounter: '<ul><li><strong>%curr%</strong></li><li>of</li><li>%total%</li></ul>', // markup of counter
                tPrev: 'Previous (Left arrow key)', // title for left button
                tNext: 'Next (Right arrow key)', // title for right button
            },
            mainClass: 'mfp-fade'
        });
    });

    /*
        # - Scroll
    */

    $win.on('scroll', function() {
        get.Scroll = $win.scrollTop();

        $header.toggleClass('header--scrolled', get.Scroll > 120);
        $header.toggleClass('header--fixed', get.Scroll > 400);
        $header.toggleClass('header--visible', get.Scroll > 700);

        $filtersHead.toggleClass('scrolled', get.Scroll > 120);
        $filtersHead.toggleClass('fixed', get.Scroll > 400);
        $filtersHead.toggleClass('visible', get.Scroll > 700);

        $('.btn-filter').removeClass('expanded');

        if ( get.WinWidth > 767 && !$filtersHead.hasClass('visible') && $filtersHead.hasClass('fixed') ){
            $('.filters.current').show();
        }

        calcFilterMobile();

        if (is.Mobile) {
            $filtersHead.find('.section__head-inner').slideUp();
        } else {
            if ($filtersHead.hasClass('visible')) {
                $filtersHead.find('.section__head-inner').stop(false, true).slideUp();
            }

            if ($filtersHead.hasClass('visible')) {
                $filtersHead.find('.section__head-inner').scrollLock('enable');
            } else {
                $filtersHead.find('.section__head-inner').scrollLock('disable');
            }


            //  add negative margin-bottom to compensate for the animation gutter left at the bottom
            // articleHighestOffsetBottom = 0;
            // var articlesOffsetBottom = articlesOffsetTop + articlesHeight;

            // $('.articles--four:not(.articles--four-static)').find('.article').each(function(){
            //     var $articleInner = $(this).find('.article__inner');
            //     var articleInnerOffsetTop = $articleInner.offset().top;
            //     var articleInnerHeight = $articleInner.height();
            //     var articleInnerOffsetBottom = articleInnerOffsetTop + articleInnerHeight;

            //     // find bottom-article offset (after animation)
            //     if (articleHighestOffsetBottom < articleInnerOffsetBottom) {
            //         articleHighestOffsetBottom = articleInnerOffsetBottom;
            //     }
            // });

            // $('.articles--four:not(.articles--four-static)').css('margin-bottom', -articlesOffsetBottom + articleHighestOffsetBottom);


            // Animate .intro-secondary Filter grayscale
            setTimeout(function(){
                $('.intro-secondary').each(function() {
                    var $this = $(this);
                    var $overlay = $this.find('.intro__image-overlay');
                    var $image = $this.find('.intro__image-inner');
                    var overlayOpacity = $overlay.css('opacity');

                    if ($overlay.length) {
                        $image.css('filter', 'grayscale(' + overlayOpacity + ')');
                    }
                });
            },400);
        }
    });

    /*
        # - Resize Orientationchange
    */
    $win.resize(function () {    
        waitForFinalEvent(function(){
            if ($('.articles--four:not(.articles--four-static)').length) {
                $('.articles--four').isotope('destroy');

                
                $('.articles--four:not(.articles--four-static').remove();
                dataArticles.appendTo(dataArticlesParent);
                

                $('.articles--four').isotope({
                    filter: '*',
                    sortBy : 'original-order'
                });

                calcArticlesPosition();
                addArticlesAnimation();
                scrollme.init();
            }
        }, 1000, "scrollme");
    });
    $win.on('resize orientationchange', function(e) {
        if (get.WinWidth !== $win.width()) {
            addDeviceResolution();

            sliderMobileInit();
            changeImage();
            lockSectionFilter();
            articlesRelated();
            feedTicker();

            if (!is.Mobile || !is.Tablet) {
                filterHeadInitialHeight = $filtersHead.outerHeight();
                calcFilterMobile();
            }

            fixTickerHeight();

            $('.slider-ticker').each(function(){
                var speed = $(this).data('speed');

                $(this).find('.slider__slides').liMarquee('update');
            });

            // if (is.Mobile) {
                $('.articles--four, .articles--two').on( 'layoutComplete', function( event, filteredItems ) {
                    calcArticlesPosition();
                    addArticlesAnimation();
                });
            // } else {
            //     // Reload the articles
            //     setTimeout(function() {
            //         // if ($('.articles--four:not(.articles--four-static').length) {
            //         //     $('.articles--four:not(.articles--four-static').remove();
            //         //     dataArticles.appendTo(dataArticlesParent);
            //         // }

            //         //$('.articles--four').isotope('layout');

            //         calcArticlesPosition();
            //         addArticlesAnimation();
            //     },400);
            // }
        }
    });

    $win.on('orientationchange', function() {
        setTimeout(function(){
            if (is.Mobile && window.matchMedia('(orientation: landscape)').matches) {
                if ($('.jsRotateForGallery').length && $('.jsGallery').length) {
                    $('.jsGallery').first().find('a').trigger('click');

                    return false;
                }
            }
        },200);
    });

    window.initMap = function (){
        $('.map').each(function(){
            var $this = $(this);
            var map;
            var mapId = $this.attr('id');
            var fileName = $this.data('file');

            $.getJSON(main_theme.template_url + '/ajax/' + fileName + '.json').then(function(data){
                var styles = data.map.styles;
                var zoom = data.map.zoom;
                var lat = data.map.lat;
                var lng = data.map.lng;
                var coordinates = {lat: lat, lng: lng};

                map = new google.maps.Map(document.getElementById(mapId), {
                    zoom: zoom,
                    center: coordinates,
                    styles: styles,
                    disableDefaultUI: true
                });

                data.pins.forEach( function (pin) {
                    var marker = new google.maps.Marker({
                        map: map,
                        position: {
                            lat: pin.lat,
                            lng: pin.lng
                        },
                        icon: {
                            url: main_theme.template_url + '/' + pin.src,
                            size: {
                                width: pin.width,
                                height: pin.height
                            },
                            scaledSize: {
                                width: pin.width,
                                height: pin.height
                            }
                        }
                    });
                });

                $win.on('resize orientationchange', function(){
                    map.setCenter(coordinates);
                });
            });
        });
    }

    /*
        # - Functions -
    */

    function lockSectionFilter() {
        if (is.Mobile) {
            $('.section-filter .section__head').scrollLock('enable');
            $('.section-filter .section__head-inner').scrollLock('enable');
        } else {
            $('.section-filter .section__head').scrollLock('disable');
            $('.section-filter .section__head-inner').scrollLock('disable');
        }
    }

    function calcFilterMobile(getHeight) {
        var $section = $('.section-filter');
        var $sectionHead = $section.find('.section__head');
        var $sectionBody = $section.find('.section__body');
        var filterHeight = $sectionHead.outerHeight();

        // Default value fix for IE.
        getHeight = getHeight || false;

        if (is.Mobile) {
            if ($sectionHead.hasClass('scrolled')) {
                $sectionBody.css('padding-top', filterHeight);
            } else {
                $sectionBody.css('padding-top', '');
            }
        } else {
            if (getHeight) {
                filterHeadInitialHeight = $filtersHead.outerHeight();
            }

            $sectionBody.css('padding-top', filterHeadInitialHeight);
        }
    }

    function accordionSetup() {
        $(".section--accordion-item-title-inner").on("click", function(){
            let $item = $(this).closest('.section--accordion-item');
            $item.toggleClass('active');
        });
    }

    function calcArticlesPosition(){
        if(!$('.articles--four').hasClass('calculating')){
            $('.articles--four').addClass('calculating')
            $('.articles--four').each(function(){
                var $articles = $(this);
                var $sectionBody = $articles.closest('.section__body');
                var sectionBodyWidth = $sectionBody.width();
                var sectionBodyOffsetLeft = $sectionBody.offset().left;

                $(this).find('.article').each(function() {
                    var $article = $(this);
                    var $articleInner = $article.find('.article__inner');
                    var offsetLeft = $articleInner.offset().left;
                    var articleToBodyOffset = offsetLeft - sectionBodyOffsetLeft;
                    var isLeft;
                    var isFirst;
                    var isSecond;
                    var isThird;

                    $article.removeClass('first second third fourth left right');

                    if (is.Desktop) {
                        isFirst = (articleToBodyOffset == 0);
                        isSecond = (articleToBodyOffset > sectionBodyWidth/4 && articleToBodyOffset < sectionBodyWidth/2);
                        isThird = (articleToBodyOffset > sectionBodyWidth/2 && articleToBodyOffset < sectionBodyWidth/1.333);

                        if (isFirst) {
                            $article.addClass('first');
                        } else if (isSecond) {
                            $article.addClass('second');
                        } else if (isThird) {
                            $article.addClass('third');
                        } else {
                            $article.addClass('fourth');
                        }
                    } else if (is.DesktopSmall || is.Tablet) {
                        isFirst = (articleToBodyOffset == 0);
                        isSecond = (articleToBodyOffset > sectionBodyWidth/3 && articleToBodyOffset < sectionBodyWidth/1.5);

                        if (isFirst) {
                            $article.addClass('first');
                        } else if (isSecond) {
                            $article.addClass('second');
                        } else {
                            $article.addClass('third');
                        }
                    } else if (is.Mobile) {
                        isLeft = (offsetLeft + $articleInner.width()) < $win.width()/2;

                        if (isLeft) {
                            $article.addClass('left');
                        } else {
                            $article.addClass('right');
                        }
                    }
                });
            });
            $('.articles--four').removeClass('calculating')
        }
        if(!$('.articles--two .article').hasClass('calculating')){
            $('.articles--two .article').addClass('calculating')
            $('.articles--two .article').each(function() {
                var $article = $(this);
                var _offsetLeft = $article.offset().left;
                var isLeft = (_offsetLeft + $article.width()) < $win.width()/2;

                if (isLeft) {
                    $article.addClass('left').removeClass('right');
                } else {
                    $article.addClass('right').removeClass('left');
                }
            });
            $('.articles--two .article').removeClass('calculating')
        }
    }

    function addArticlesAnimation(){
        if(!$('.articles--four').hasClass('addArticlesAnimation')){
            $('.articles--four').addClass('addArticlesAnimation')
            $('.articles--four').each(function() {
                var $articles = $(this);
                articlesHeight = $articles.height();
                articlesOffsetTop = $articles.offset().top;

                if (!$articles.hasClass('articles--four-static')) {
                    if (is.Desktop) {
                        // First
                        $articles.find('.first').each(function(){
                            addScrollMeAttributes($(this), 'span', '0', '1', 'linear', -articlesHeight/25);
                        });

                        // Second
                        $articles.find('.second').each(function(){
                            addScrollMeAttributes($(this), 'span', '0', '1', 'linear', -articlesHeight/8);
                        });

                        // Third
                        $articles.find('.third').each(function(){
                            addScrollMeAttributes($(this), 'span', '0', '1', 'linear', -articlesHeight/25);
                        });

                        // Fourth
                        $articles.find('.fourth').each(function(){
                            addScrollMeAttributes($(this), 'span', '0', '1', 'linear', -articlesHeight/8);
                        });
                    } else if (is.DesktopSmall || is.Tablet) {
                        // First
                        $articles.find('.first').each(function(){
                            addScrollMeAttributes($(this), 'span', '0', '1', 'linear', -articlesHeight/25);
                        });

                        // Second
                        $articles.find('.second').each(function(){
                            addScrollMeAttributes($(this), 'span', '0', '1', 'linear', -articlesHeight/8);
                        });

                        // Third
                        $articles.find('.third').each(function(){
                            addScrollMeAttributes($(this), 'span', '0', '1', 'linear', -articlesHeight/14);
                        });
                    }

                    scrollme.init()
                }
            });
            $('.articles--four').removeClass('addArticlesAnimation')
        }
        $('.articles--two').each(function() {
            var $articles = $(this);

            if (is.DesktopSmall || is.Desktop) {
                // Left
                addScrollMeAttributes($articles.find('.article.left'), 'span', '0', '1', 'linear', '-400');
                // Right
                addScrollMeAttributes($articles.find('.article.right'), 'span', '0', '1', 'linear', '-200');
            } else if (is.Tablet) {
                // Left
                addScrollMeAttributes($articles.find('.article.left'), 'span', '0', '1', 'linear', '-250');
                // Right
                addScrollMeAttributes($articles.find('.article.right'), 'span', '0', '1', 'linear', '-100');
            }
        });
    }

    function addScrollMeAttributes(element, when, from, to, easing, translatey) {
        if (!element.closest('.articles').hasClass('scrollme')) {
            element.closest('.articles').addClass('scrollme');
        }

        element.find('.article__inner').addClass('animateme').attr({
            'data-when': when,
            'data-from': from,
            'data-to': to,
            'data-easing': easing,
            'data-translatey': translatey
        });
    }

    function changeImage() {
        $('[data-image-desktop]').each(function() {
            var $this = $(this);

            if (is.Mobile) {
                resolution = 'mobile';
            } else {
                resolution = 'desktop';
            }

            var imageSrc = $this.data('image-' + resolution);
            $this.css('background-image', 'url(' + imageSrc + ')');
        });
    }

    function calcClonedImageSize(baseImage, clonedImage) {
        var width = baseImage.css('width');
        var height = baseImage.css('height');

        clonedImage.css({
            width: width,
            height: height
        });
    }

    function articlesOverlap() {
         var controller = new ScrollMagic.Controller();

         $('.section--overlap .article').each(function() {
            var $article = $(this);
            var $overlay = $article.find('.article__image-overlay');
            var $image = $article.find('picture');
            var $articleInner = $article.find('.article__inner');

            // Add Front Article Class
            $article.on('mouseover', function() {
                $(this).addClass('front').siblings().removeClass('front');
            });

            // Stop if the Article has no overlay
            if (!$overlay.length) {
                return false;
            }

            $image.clone().appendTo($overlay.find('span'));

            calcClonedImageSize($image, $overlay.find('img'));

            var $target = $($overlay.data('target'));

            calcOverlap();

            // Recalculate on resize
            $win.on('resize orientationchange', function() {
                calcOverlap();
                calcClonedImageSize($image, $overlay.find('img'));
            });

            function calcOverlap() {
                var targetHeight = $target.find('.article__image').outerHeight();
                var articlesOffsetGap = $article.offset().top - $target.offset().top;

                $overlay.css('margin-top', -articlesOffsetGap);
                $overlay.find('img').css('margin-top', articlesOffsetGap);

                if ($article.index() % 2 == 0) {
                    // if the article is on the left side of the screen
                    $overlay.css({
                        right: 0
                        // height: targetHeight
                    });

                    $overlay.find('img').css({
                        right: 0
                    });
                } else {
                    // if the article is on the right side of the screen
                    $overlay.css({
                        left: 0
                        // height: targetHeight
                    });

                    $overlay.find('img').css({
                        left: 0
                    });
                }
            }
        });

        $('.section--overlap .articles').each(function() {
            var $articles = $(this);
            var scenes = [];
            var data1 = $articles.find('.article:first-child').data('scroll');
            var data2 = $articles.find('.article:nth-child(2)').data('scroll');

            var $articlesOverlayPicture = $articles.find('.article .article__image-overlay picture');

            var $article1 = $articles.find('.article:first-child');
            var $article2 = $articles.find('.article:nth-child(2)');

            var $article1Overlay = $article1.find('.article__image-overlay');
            var $article1OverlayImage = $article1.find('.article__image-overlay img');

            var $article2Overlay = $article2.find('.article__image-overlay');
            var $article2OverlayImage = $article2.find('.article__image-overlay img');

            var article1ImageHeight = $article1.find('.article__image').height();
            var article1ImageOffsetTop = $article1.find('.article__image').offset().top;
            var article1ImageOffsetBottom = article1ImageOffsetTop + article1ImageHeight;

            var article2ImageHeight = $article2.find('.article__image').height();
            var article2ImageOffsetTop = $article2.find('.article__image').offset().top;
            var article2ImageOffsetBottom = article2ImageOffsetTop + article2ImageHeight;

            var scene1Value;
            var scene2Value;
            var article1Progress;
            var article2Progress;
            var articleHeight;
            var animationDiff;

            $articles.find('.article').each(function() {
                var $article = $(this);
                var $inner = $article.find('.article__inner');
                var dataScroll = $article.data('scroll');

                var parallax = TweenMax.to($inner, 1, {
                    y: dataScroll,
                    ease: Linear.easeNone
                });

                var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: 1,
                    duration: '150%'
                })
                .setTween(parallax)
                .addTo(controller);

                scenes.push(scene);
            });

            scenes.forEach(function(scene, index) {
                $win.on('resize orientationchange', function(){
                    setTimeout(function(){
                        scene.trigger('progress');
                    }, 500);
                });

                scene.on('progress', function(event) {
                    article1ImageHeight = $article1.find('.article__image').height();
                    article1ImageOffsetTop = $article1.find('.article__image').offset().top;
                    article1ImageOffsetBottom = article1ImageOffsetTop + article1ImageHeight;
                    article2ImageOffsetTop = $article2.find('.article__image').offset().top;
                    article2ImageHeight = $article2.find('.article__image').height();
                    article2ImageOffsetBottom = article2ImageOffsetTop + article2ImageHeight;

                    if (index == 0) {
                        scene1Value = event.progress;
                        article1Progress = data1*scene1Value;
                    } else if (index = 1 ) {
                        scene2Value = event.progress;
                        article2Progress = data2*scene2Value;
                    }

                    if (article1ImageOffsetTop < article2ImageOffsetTop) {
                        // if Left Article is faster
                        articleHeight = $articles.find('.article:first-child').find('img').height();
                        animationDiff = article1Progress - article2Progress;

                        if (article1ImageOffsetBottom > article2ImageOffsetBottom) {
                            // if it's also bigger
                            $articles.find('.article__image-overlay picture').css('height', article2ImageHeight + 'px');

                            $article1Overlay.css('top', -animationDiff + 'px');
                            $article1OverlayImage.css('top', animationDiff + 'px');

                            $article2Overlay.css({
                                top:  '',
                                bottom: ''
                            });

                            $article2OverlayImage.css({
                                top: '',
                                bottom: ''
                            });
                        } else {
                            $articlesOverlayPicture.css('height', articleHeight + animationDiff + 'px');

                            $article1Overlay.css({
                                top: '',
                                bottom: ''
                            });

                            $article1OverlayImage.css({
                                top: '',
                                bottom: ''
                            });

                            $article2Overlay.css({
                                top: 0,
                                bottom: 'auto'
                            });

                            $article2OverlayImage.css({
                                top: 0,
                                bottom: 'auto'
                            });
                        }
                    } else if (article1ImageOffsetTop > article2ImageOffsetTop) {
                        // if Right Article is faster
                        articleHeight = $articles.find('.article:nth-child(2)').find('img').height();
                        animationDiff = article2Progress - article1Progress;

                        if (article1ImageOffsetBottom < article2ImageOffsetBottom) {
                            // if it's also bigger
                            $articles.find('.article__image-overlay picture').css('height', article1ImageHeight + 'px');

                            $article2Overlay.css({
                                top: -animationDiff + 'px',
                                bottom: ''
                            });

                            $article2OverlayImage.css({
                                top: animationDiff + 'px',
                                bottom: ''
                            });
                        } else {
                            $articlesOverlayPicture.css('height', articleHeight + animationDiff + 'px');

                            $article2Overlay.css({
                                top: -animationDiff,
                                bottom: ''
                            });

                            $article2OverlayImage.css({
                                top: animationDiff,
                                bottom: ''
                            });

                            $article1Overlay.css({
                                top: 0,
                                bottom: 'auto'
                            });

                            $article1OverlayImage.css({
                                top: 0,
                                bottom: 'auto'
                            });
                        }
                    }
                });
            });
        });
    }

    function articlesRow() {
        $('.jsArticlesRow').each(function() {
            var $section = $(this);
            var $articles = $section.find('.articles-row');
            var $article = $section.find('.article-row');

            $win.on('scroll', function() {
                if (get.Scroll + $win.height() / 2 > $section.offset().top && get.Scroll + $win.height() / 1.25 < $section.offset().top + $section.outerHeight()) {
                    // section in range
                    $article.each(function() {
                        var $this = $(this);

                        if (get.Scroll + $win.height() / 2 > $this.offset().top && get.Scroll + $win.height() / 2 < $this.offset().top + $this.outerHeight()) {
                            // image is in range
                            $this.addClass('show-image');
                        } else {
                            // image is out of range
                            $this.removeClass('show-image');
                        }
                    });
                } else {
                    // section out of range
                    $article.each(function() {
                        $(this).removeClass('show-image');
                    });
                }
            });
        });
    }

    function sliderMobileInit() {
        $('.articles-row').each(function() {
            var $this = $(this);

            if (is.Mobile || is.Tablet) {
                if (!$this.hasClass('slick-initialized')) {
                    $this.slick({
                        arrows: true,
                        dots: false
                    });
                }
            } else {
                if ($this.hasClass('slick-initialized')) {
                    $this.slick('unslick');
                }
            }
        });
    }

    function articlesRelated() {
        $('.articles-related').each(function(){
            var $this = $(this);
            var $clip = $this.find('.articles__clip');
            var $articles = $clip.find('.article');
            var articleWidth = 0;
            var speed = $this.data('speed');

            if($articles.length < 4)return false;

            $articles.each(function() {
                articleWidth = articleWidth + $(this).outerWidth(true);
            });

            if (is.Mobile) {
                if ($clip.hasClass('ticker-initialized')) {
                    $clip.removeClass('ticker-initialized').liMarquee('destroy');

                    $clip.find('.cloned').remove();
                }

                if (!$clip.hasClass('slick-initialized')) {
                    $clip.slick({
                        arrows: true,
                        dots: false
                    });
                }
            } else {
                if ($clip.hasClass('slick-initialized')) {
                    $clip.slick('unslick');
                }

                if ($clip.width() >= articleWidth && !$clip.find('.cloned').length) {
                    $clip.append($articles.clone().addClass('cloned'));
                }

                if (!$clip.hasClass('ticker-initialized')) {
                    $clip.addClass('ticker-initialized').liMarquee({
                        scrollamount: speed
                    });
                }
            }
        });
    }

    function feedTicker() {
        $('.feed').each(function(){
            var $this = $(this);
            var $clip = $this.find('.feed__clip');
            var speed = $this.data('speed');

            if (is.Mobile) {
                if ($clip.hasClass('ticker-initialized')) {
                    $clip.removeClass('ticker-initialized str_wrap').liMarquee('destroy');
                }
            } else {
                if (!$clip.hasClass('ticker-initialized')) {
                    $clip.addClass('ticker-initialized str_wrap').liMarquee({
                        scrollamount: speed
                    });
                }
            }
        });
    }

    function sliderTicker() {
        $('.slider-ticker').each(function(){
            var speed = $(this).data('speed');

            if ($(this).hasClass('slider-ticker--to-right')) {
                $(this).find('.slider__slides').liMarquee({
                    direction: 'right',
                    scrollamount: speed
                });
            } else {
                $(this).find('.slider__slides').liMarquee({
                    scrollamount: speed
                });
            }
        });
    }

    function fixTickerHeight() {
        $('.ticker-initialized').each(function(){
            var $this = $(this);
            var itemHeight = $this.children().height();

            $this.css('height', itemHeight);
        });
    }

    function detectIE() {
        var ua = window.navigator.userAgent;
        var rv = ua.indexOf('rv:');
        var msie = ua.indexOf('MSIE ');
        var edge = ua.indexOf('Edge/');
        var trident = ua.indexOf('Trident/');

        if (msie > 0) {
            // IE 10 or older
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        if (trident > 0) {
            // IE 11
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        if (edge > 0) {
            // Edge (IE 12+)
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        return false;
    }

    function loadVideoAPIs() {
        if ($('.video-youtube').length) {
            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        if ($('.video-vimeo').length) {
            var tag = document.createElement('script');

            tag.src = "https://player.vimeo.com/api/player.js";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    }

    window.onYouTubeIframeAPIReady = function() {
        var $youTubeBg = $('.video-bg--html .video-youtube');

        $youTubeBg.each(function(i, el) {
            var player = new YT.Player(el);

            window.ytBgPlayer[$(el).attr('id')] = player;
        });
    }

    function fullscreenVideo() {
        var $videoBg = $('.video-bg--html');

        $videoBg.each(function(i, el) {
            var $this = $(this);
            var $video = $this.find('video, iframe');
            var $videoSound = $this.find('.video__sound');

            if ($video.is('[muted]') || $video[0].src.indexOf('mute=1') !== -1 || $video[0].src.indexOf('muted=1') !== -1) {
                $this.addClass('muted');
            }

            $videoSound.on("click", function (e) {
                e.preventDefault();

                var $video = $(this).prev('video, iframe');

                if ($(this).parent().hasClass('muted')) {
                    // Mute prev video
                    $videoBg.each(function() {
                        $(this).addClass('muted');

                        var $video = $(this).find('video, iframe');

                        if ($video.is('video')) {
                            $video[0].muted = true;
                        } else {
                            if ($video.hasClass('video-vimeo')) {
                                var player = new Vimeo.Player($video[0]);

                                player.setVolume(0);
                            } else if ($video.hasClass('video-youtube')) {
                                window.ytBgPlayer[$video.attr('id')].mute();
                            }
                        }
                    });

                    if ($video.is('video')) {
                        $video[0].muted = false;
                    } else {
                        if ($video.hasClass('video-vimeo')) {
                            var player = new Vimeo.Player($video[0]);

                            player.setVolume(1);
                        } else if ($video.hasClass('video-youtube')) {
                            window.ytBgPlayer[$video.attr('id')].unMute();
                        }
                    }

                    $(this).parent().removeClass('muted');
                } else {
                    if ($video.is('video')) {
                        $video[0].muted = true;
                    } else {
                        if ($video.hasClass('video-vimeo')) {
                            var player = new Vimeo.Player($video[0]);

                            player.setVolume(0);
                        } else if ($video.hasClass('video-youtube')) {
                            window.ytBgPlayer[$video.attr('id')].mute();
                        }
                    }

                    $(this).parent().addClass('muted');
                }
            });
        });
    }

    function videos() {
        var $videoContainer = $('.video-simple');
        var $video = $videoContainer.find('video, iframe');
        var $btnPlay = $videoContainer.find('.video__play');

        $btnPlay.click(function(e){
            e.preventDefault();

            var $video = $(this).siblings('iframe');

            if ($video.hasClass('video-youtube')) {
                $(this).closest('.video-simple').addClass('playing');

                if (typeof(window.ytPlayer[$video.attr('id')]) === "undefined") {
                    var player = new YT.Player($video[0], {
                        events: {
                            'onReady': function(e) {
                                e.target.playVideo();
                                $video.addClass('ready');
                            },
                            'onStateChange': function (e) {
                                if(e.data==YT.PlayerState.ENDED){
                                    if (e.target.a.src.indexOf('loop=1') === -1) {
                                        $(e.target.a).closest('.video-simple').removeClass('playing');
                                    }
                                }
                            }
                        }
                    });

                    window.ytPlayer[$video.attr('id')] = player;
                } else {
                    window.ytPlayer[$video.attr('id')].playVideo();
                }
            } else if ($video.hasClass('video-vimeo')) {
                $(this).closest('.video-simple').addClass('playing');

                var player = new Vimeo.Player($video[0]);

                player.play();

                player.on('ended', function (data) {
                    player.getLoop().then(function(loop) {
                        if (!loop) {
                            $video.closest('.video-simple').removeClass('playing');
                            setTimeout(function() {
                                player.unload();
                            }, 400);
                        }
                    });
                });

            } else {
                $(this).closest('.video-simple').addClass('playing').find('video')[0].play();
            }
        });

        $video.on('ended', function(){
            $(this).closest('.video-simple').removeClass('playing');
        });
    }

    function addBaseClickEvents() {
        $body.on('click touchstart', function(event) {
            var $target = $(event.target);

            if (is.Tablet || is.Mobile) {
                if (!$target.parents('.nav').length) {
                    $('.nav li').removeClass(classes.Hover);
                }
            }
        });

        $('.jsReadMore').click(function(e){
            e.preventDefault();

            var $this = $(this);
            var $target = $($this.attr('href'));

            $target.stop().slideToggle();
            $this.toggleClass(classes.Expanded);
        });

        $('.header__nav').on('click touchstart', function(event) {
            var $target = $(event.target);

            if (!$target.parents('.header__nav').length) {
                $body.removeClass(classes.ShowNavMain);
            }
        });

        $('.nav a').click(function(event) {
            if (is.Tablet || is.Mobile) {
                var $this = $(this);
                var $parent = $this.parent();

                if ($parent.find('> ul').length && !$parent.hasClass(classes.Hover)) {
                    event.preventDefault();

                    $parent.toggleClass(classes.Hover).siblings().removeClass(classes.Hover);
                }
            }
        });

        $('.btn-menu').click(function(event) {
            event.preventDefault();

            $body.toggleClass(classes.ShowNavMain);
        });

        $('.btn-filter').click(function(e){
            e.preventDefault();

            var filterHeight;
            var $target = $($(this).attr('href') + '.current');

            $(this).toggleClass('expanded');
            $target.slideToggle();
        });

        $('body').on('click', '.link-filter', function(e) {
            e.preventDefault();

            var $this = $(this),
                $filterWrapper = $this.closest('.section__head-inner'),
                $otherFilter = $filterWrapper.siblings('.section__head-inner');

            //var $target = $(this).closest('.section__head-inner').siblings('.section__head-inner');

            // $(this).closest('.section__head-inner').removeClass('current').hide().siblings('.section__head-inner').addClass('current').show();
            $filterWrapper.removeClass('current').hide();
            $otherFilter.addClass('current').show();

            if ($otherFilter.find('.slider-ticker').length) {
                $('.section-filter .slider-ticker').each(function(){
                    $(this).find('.slider__slides').liMarquee('update');
                });
            }

            calcFilterMobile(true);
        });

        $('.list-filter a, .section-filter .slider-ticker a').click(function(e){
            var text = $(this).text();

            e.preventDefault();

            $('.articles--four').isotope({
                filter: '*',
                sortBy : 'original-order'
            });

            if ($(this).data('filter') === 'latest') {
                $('.articles--four').isotope({
                    filter: '*',
                    sortBy: 'date',
                    sortAscending: false
                });
            } else {
                $('.articles--four').isotope({
                    filter: $(this).data('filter'),
                    sortBy : 'original-order'
                });
            }


            setTimeout(function() {
                calcArticlesPosition();
            },400);

            // Current class handler
            $(this).parent().addClass('current').siblings().removeClass('current');

            // replace Text
            $(this).closest('.section__head').find('.btn-filter--mobile').removeClass('expanded').find('.closed').html('Filter <span>–</span> <span class="current">' + text + '</span>');

            if (is.Mobile) {
                $(this).closest('.section__head-inner').slideUp();
            }
        });

        $('.search-input').on('focus blur', function(e) {
            var $this = $(this),
                $form = $this.parents('.searchForm'),
                isSubmitting = e.relatedTarget && e.relatedTarget.type === 'submit' ? true : false;

            if (!$form.hasClass('open')) {
                $form.addClass('open');
            } else if (!isSubmitting) {
                $form.removeClass('open');
            }
        });
    }

    function searchFormTransDelay() {
        // Calc/add transition-delay to nav search form based on number of nav items.
        var $searchForm = $('.nav .searchForm');

        if ($searchForm.length) {
            var $navItems = $('.nav > ul > li'),
                delay     = parseFloat($navItems.eq(1).css('transition-delay')) * $navItems.length;

            $searchForm.css('transition-delay', delay + 's');
        }
    }

    function smoothScroll() {
        $('a[href*="#"]:not([href="#"]):not(.btn-filter)').click(function() {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                if (target.length) {

                    // add in header height to stroll so that no content is overlapped
                    var $header = $('.header');
                    var $header_title = $('.header__title');
                    var header_height = $header.outerHeight();

                    // if( $header_title.length > 0 ){
                    //     header_height = header_height + $header_title.outerHeight();
                    // }

                    $('html,body').animate({
                        scrollTop: target.offset().top - header_height
                    }, 1000);

                    return false;
                }
            }
        });
    }

    function addDeviceResolution(){
        get.WinWidth = $win.width();
        get.WinHeight = $win.height();

        is.Desktop = get.WinWidth > 1200;
        is.DesktopSmall = get.WinWidth <= 1200 && get.WinWidth >= 1025;
        is.Mobile = get.WinWidth <= 767;
        is.Tablet = get.WinWidth <= 1024 && get.WinWidth >= 768;
    }

    function window_width() {
        var myWidth = 0;
        if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
        else if (document.documentElement && document.documentElement.clientWidth)
            myWidth = document.documentElement.clientWidth;
        else if (document.body && document.body.clientWidth)
            myWidth = document.body.clientWidth;
        return myWidth;
    }

    function window_height() {
        var myHeight = 0;
        if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
        else if (document.documentElement && document.documentElement.clientHeight)
            myHeight = document.documentElement.clientHeight;
        else if (document.body && document.body.clientHeight)
            myHeight = document.body.clientHeight;
        return myHeight;
    }
})(jQuery, window, document);
